import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  Container,
  HeadWrapper,
  PageTitle,
  TabContent,
} from './styles'
import {
  BackArrow,
  TopProgress,
} from '../../../components'
import { ukrsibService } from '../../../api'
import { useUi } from '../../../context/ui.context'
import { usePageTitle } from '../../../context/navigationContext'
import SettingsTab from './settings'
import StatusTab from './status'

const UkrsibPage: FC = () => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const { viewAlert } = useUi()
  usePageTitle(t("UKRSIB_CONFIG"));
  const [config, setConfig] = useState<any>(null)
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const configLoadedRef = React.useRef(false)

  useEffect(() => {
    if (configLoadedRef.current) {
      return
    }

    configLoadedRef.current = true
    ukrsibService.getConfig()
      .then((res) => {
        setConfig(res.data)
        setPageLoading(false)
      })
      .catch((err) => {
        viewAlert({
          severity: 'error',
          message: err?.response?.data?.detail || t("ERROR_OCCURRED"),
        })
        setPageLoading(false)
      })
  }, [])

  if (pageLoading) return <TopProgress loading={pageLoading} />

  return (
    <Container>
      <TopProgress loading={!pageLoading && false} />
      <BackArrow fallbackPath="/billing/gateways" />
      <HeadWrapper>
        <PageTitle>
          {t("UKRSIB_CONFIG")}
        </PageTitle>
      </HeadWrapper>
      <TabContent style={{ paddingTop: 0 }}>
        <StatusTab />
      </TabContent>
      <TabContent>
        <SettingsTab config={config} />
      </TabContent>
    </Container>
  )
}

export default UkrsibPage
